<template>
  <div id="app" class="d-flex flex-column h-100" :key="view">
    <Navigation :display="displayNav" />
    <div class="container-fluid flex-grow-1 p-0">
      <router-view />
    </div>
  </div>
</template>

<script>
import Navigation from "./components/Navigation";
export default {
  components: {
    Navigation,
  },
  data: function () {
    return {
      view: null,
      
      newAccount: true,
    };
  },
  computed: {
    displayNav() {
      // Check if page is login
      if(this.$route.name == "login"){
          return false;
      }else if(this.$route.name == "register"){
        return false;
      }else {
        return true;
      }
    },     
  },
  mounted() {
    /*if(localStorage.newAccount){
        this.newAccount = true;
    }*/
  },
};
</script>
